<script lang="ts">
    import KpValueEditorForceSettings from '../../commons/value-editors/kp-value-editor-force-settings/KpValueEditorForceSettings.svelte';
    import KpValueEditor from '../../commons/value-editors/kp-value-editor/KpValueEditor.svelte';
    import type {ForceSetting} from '../../commons/value-editors/kp-value-editor-force-settings/types';
    import type {EditableField, EditableFieldType} from '../../typings/portaro.be.types';
    import {ValueEditorSize} from '../../commons/value-editors/types';
    import {createEventDispatcher} from 'svelte';
    import {cloneDeep} from 'lodash';

    export let fieldType: EditableFieldType;
    export let field: EditableField;

    const dispatch = createEventDispatcher<{cancel: void, save: void}>();

    const customEditorSettings: ForceSetting[] = [
        {type: 'acceptable', options: {switchToInlineModeThreshold: 1}, strategy: 'merge'},
        {type: 'single-acceptable', options: {switchToInlineModeThreshold: 1}, strategy: 'merge'},
        {type: 'multiple-acceptable', options: {switchToInlineModeThreshold: 1}, strategy: 'merge'}]

    const originalIndicator1 = cloneDeep(field.ind1);
    const originalIndicator2 = cloneDeep(field.ind2);

    function cancel() {
        field.ind1 = originalIndicator1;
        field.ind2 = originalIndicator2;
        dispatch('cancel');
    }

    function save() {
        dispatch('save');
    }

</script>

<template>
    <form name="indicators" class="form-inline">
        <KpValueEditorForceSettings forceSettings={customEditorSettings}>
            <div class="input-group">
            <KpValueEditor type={fieldType.indicator1Type.editor.type}
                           options={fieldType.indicator1Type.editor.options}
                           validations={fieldType.indicator1Type.editor.validations}
                           bind:model={field.ind1}
                           editorId={`${field.id}_ind1`}
                           size={ValueEditorSize.XS}/>
            </div>
            <div class="input-group">
            <KpValueEditor type={fieldType.indicator2Type.editor.type}
                           options={fieldType.indicator2Type.editor.options}
                           validations={fieldType.indicator2Type.editor.validations}
                           bind:model={field.ind2}
                           editorId={`${field.id}_ind2`}
                           size={ValueEditorSize.XS}/>
            </div>
        </KpValueEditorForceSettings>

        <div class="input-group">
            <button type="button" class="btn btn-default btn-xs field-indicators-save-button" on:click={save}>
                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>
                OK
            </button>
        </div>
        <div class="input-group">
            <button type="button" class="btn btn-default btn-xs field-value-edit-cancel-button" on:click={cancel}>
                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
                Storno
            </button>
        </div>
    </form>
</template>
